export const userProfileRoutePaths = {
  main: {
    path: 'user/:userId',
    fullPath: '/user',
  },
};
